import React from 'react';
import { useCart } from '../../context/CartContext';
import { useSiteContent } from '../../context/SiteContentContext';
import { digitalProducts } from '../../data/shopData';
import Button from '../../common/Button';
import SafeIcon from '../../common/SafeIcon';
import OptimizedImage from '../OptimizedImage';
import * as FiIcons from 'react-icons/fi';
import { supabase } from '../../lib/supabase';

const { FiPlus } = FiIcons;

const CartUpsell = () => {
    const { cartItems, addToCart } = useCart();
    const { getSetting } = useSiteContent();
    const [manualUpsell, setManualUpsell] = React.useState(null);

    const upsellProductId = getSetting('cart_upsell_product_id', '');

    React.useEffect(() => {
        if (!upsellProductId) {
            setManualUpsell(null);
            return;
        }

        const fetchManualUpsell = async () => {
            // Check if it's in our static data first
            const staticProduct = digitalProducts.find(p => p.id === upsellProductId);
            if (staticProduct) {
                setManualUpsell(staticProduct);
                return;
            }

            // Otherwise fetch from DB
            const { data } = await supabase
                .from('products')
                .select('*')
                .eq('id', upsellProductId)
                .single();

            if (data) setManualUpsell(data);
        };

        fetchManualUpsell();
    }, [upsellProductId]);

    // Find a product not in cart to upsell
    let upsellProduct = null;

    if (manualUpsell && !cartItems.some(item => item.id === manualUpsell.id)) {
        upsellProduct = manualUpsell;
    } else {
        // Fallback to automatic logic
        upsellProduct = digitalProducts.find(p =>
            !cartItems.some(item => item.id === p.id) &&
            p.price < 100
        );
    }

    if (!upsellProduct) return null;

    return (
        <div className="bg-amber-50 dark:bg-amber-900/20 p-4 rounded-xl border border-amber-100 dark:border-amber-900/50 my-4">
            <h4 className="text-amber-900 dark:text-amber-100 font-bold text-sm mb-3">
                Wait! Special Offer
            </h4>
            <div className="flex gap-3">
                <div className="w-16 h-16 rounded-lg bg-slate-200 dark:bg-slate-700 overflow-hidden flex-shrink-0">
                    <OptimizedImage
                        src={upsellProduct.image}
                        alt={upsellProduct.title}
                        type="thumbnail"
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="flex-1">
                    <div className="font-bold text-slate-900 dark:text-white text-sm line-clamp-1">{upsellProduct.title}</div>
                    <div className="text-slate-500 text-xs mb-2">${upsellProduct.price}</div>
                    <button
                        onClick={() => addToCart(upsellProduct)}
                        className="text-xs font-bold text-amber-700 hover:text-amber-900 dark:text-amber-400 dark:hover:text-amber-200 flex items-center transition-colors px-2 py-1 bg-amber-100 dark:bg-amber-900/40 rounded-md w-fit"
                    >
                        <SafeIcon icon={FiPlus} className="w-3 h-3 mr-1" />
                        Add to Order
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartUpsell;
